import { useState, useRef, useEffect } from "react";

import { func_validation } from "functions";


export function useTableDataPagination(props) {
    const { 
        getUserGroupPermissionList_requesting, getUserGroupPermissionList_status,
        userGroupPermissionList,

        isRenderingRequired, setIsRenderingRequired
    } = props;

    const [totalRecords, setTotalRecords] = useState();
    let tableData = useRef([]);

    function getTableData(currentPage = 0, pageSize = 10, sort, filterOptions) {
        if (func_validation.isArrayNotEmpty(userGroupPermissionList)) {
            // Get Internal role
            let userGroupPermissionList_internal = [];
            for (let i = 0; i < userGroupPermissionList.length; i++) {
                if (func_validation.isStringEqual_caseInsensitive(userGroupPermissionList[i]?.Role, "Internal")) {
                    userGroupPermissionList_internal = userGroupPermissionList[i].UserGroupPermissionList;
                    break;
                }
            }

            // Filter data
            let currentPage_formatted = currentPage * pageSize;
            let lastPage = (currentPage_formatted + pageSize);
            let tableData_new = [];
            for (let i = currentPage_formatted; (i < lastPage) && (i < userGroupPermissionList_internal.length); i++) {
                let newObj = func_validation.deepCloneObject(userGroupPermissionList_internal[i]);
                tableData_new.push(newObj);
            }

            // Save data
            tableData.current = tableData_new;
            setIsRenderingRequired(!isRenderingRequired);
            if (func_validation.isNullUndefined(totalRecords))
                setTotalRecords(userGroupPermissionList_internal.length);
        }
        else if (props.getUserGroupPermissionList) 
            props.getUserGroupPermissionList();
    }
    useEffect(() => {
        getTableData();
    }, [JSON.stringify(userGroupPermissionList)]);

    return {
        getTableData,
        tableData: tableData.current,
        totalRecords
    }

}